import { render, staticRenderFns } from "./AnnouncementBanner.vue?vue&type=template&id=bfeab98a&scoped=true&"
import script from "./AnnouncementBanner.vue?vue&type=script&lang=js&"
export * from "./AnnouncementBanner.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementBanner.vue?vue&type=style&index=0&id=bfeab98a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfeab98a",
  null
  
)

export default component.exports